import React, { createContext } from 'react'

import { Loader } from '@percept/mui'

import { useMyUser } from '@percept/hooks'

import { UserResponse } from '@percept/types'


export const UserDetailContext = createContext<UserResponse>({} as UserResponse)

export type UserDetailProviderProps = React.PropsWithChildren<{
  fallback?: JSX.Element
}>

export const UserDetailProvider = ({ children, fallback }: UserDetailProviderProps): JSX.Element => {
  const [user] = useMyUser()
  if( !user.data ){
    return fallback || <Loader preset='fullscreen' />
  }
  return (
    <UserDetailContext.Provider value={user.data}>
      { children }
    </UserDetailContext.Provider>
  )
}
